<app-loader [loading]="qssLoading" [fullPage]="true" [title]="'qss.title' | i18n"></app-loader>
<section *ngIf="!qssLoading" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'qs'"></app-stepper-component>

    <div>
        <form *ngIf="qssForm" [formGroup]="qssForm" (ngSubmit)="postValidateQssModal = true" enctype="multipart/form-data">
            <fieldset class="simulation__step" name="adhesionForm">
                <legend style="display: none">{{ 'qss.title' | i18n }}</legend>
                <!-- uiView: adhesionSteps -->
                <div data-ui-view="adhesionSteps">
                    <!-- uiView: medicalStep -->
                    <div cand-scroll-error="" class="grid-mobile-4 pull-mobile-0 no-gutter grid-12">
                        <section class="simulation__group simulation__group--qs" data-overload-controller="QssPegaseCtrl">
                            <h1 class="page-title page-title--primary">
                                {{ 'qss.title' | i18n }}
                            </h1>
                            <div>
                                <div class="grid-container warning">
                                    <div class="grid-mobile-4">
                                        <p>{{ 'qss.headerMessage' | i18n }}</p>
                                    </div>
                                </div>
                                <div class="simulation__group simulation__group--no-margin">
                                    <div class="simulation__content simulation__content--no-shadow simulation__content--no-padding">
                                        <div class="grid-12 grid-mobile-4 no-gutter">
                                            <!-- Include Question template. -->
                                            <ol class="simulation__list simulation__group--qs-summary qs-summary-wrapper">
                                                <li
                                                    *ngFor="let questionQuestionnaireSanteSimplifie of listeQuestionsQuestionnaireSanteSimplifie"
                                                    class="list-digit simulation__listItem simulation__listItem--qs-summary question grid-container not-height-weight-question"
                                                >
                                                    <div data-question-medical-workflow="" data-question="question" data-title="question.section.title" class="grid-container">
                                                        <div>
                                                            <app-question-taille-component *ngIf="questionQuestionnaireSanteSimplifie.questionTaille" [qsForm]="qssForm" [questionQuestionnaireSante]="questionQuestionnaireSanteSimplifie">
                                                            </app-question-taille-component>
                                                            <app-question-simple-component
                                                                *ngIf="!questionQuestionnaireSanteSimplifie.questionTaille"
                                                                [qssForm]="qssForm"
                                                                [questionQuestionnaireSanteSimplifie]="questionQuestionnaireSanteSimplifie"
                                                                [preambuleQuestionsSanteSimplifie]="preambuleQuestionsSanteSimplifie"
                                                            >
                                                            </app-question-simple-component>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- ngIf: adhesion.creditProject.isH2Project -->
                            <div class="grid-container acceptance__option choice-box choice-box--inline-left acceptance">
                                <input [(ngModel)]="isSaveForNextAdhChecked" [ngModelOptions]="{ standalone: true }" id="saveDataAcceptance" class="choice" type="checkbox" />
                                <label class="choice-box__label acceptance-box__label" for="saveDataAcceptance" data-tag-commander="" [appTagCommander]="'tagCo.savadata.accept.checkbox'">
                                    <span>{{ 'qs.checkbox.saveDataAcceptance' | i18n }}</span>
                                </label>
                            </div>
                            <!-- end ngIf: adhesion.creditProject.isH2Project -->
                            <div class="qs-group">
                                <div class="qss__legal--notice">
                                    {{ 'adhesion.qss.footer.legalNotice.1' | i18n }}
                                </div>
                                <div class="qss__legal--notice">
                                    {{ 'adhesion.qss.footer.legalNotice.2' | i18n }}
                                </div>
                                <div class="qss__legal--notice">
                                    {{ 'adhesion.qss.footer.legalNotice.3' | i18n }}
                                </div>
                                <div class="qss__legal--notice">
                                    {{ 'adhesion.qss.footer.legalNotice.4' | i18n }}
                                </div>
                            </div>
                            <div class="simulation__buttons simulation__buttons--light">
                                <div class="grid-4 grid-mobile-4 hide-mobile">
                                    <button id="qss-go-back" (click)="goBack()" type="button" data-tag-commander="" [appTagCommander]="'tagCo.qss.previous.button'" class="button--previous-cancel">
                                        {{ 'global.button.cancel' | i18n }}
                                    </button>
                                </div>
                                <div class="grid-4 grid-mobile-4 hide show-mobile no-gutter-mobile">
                                    <button data-tag-commander="" (click)="goBack()" [appTagCommander]="'tagCo.qss.previous.button'" type="button" class="pt-0 button--previous-cancel">
                                        {{ 'qss.button.prev' | i18n }}
                                    </button>
                                </div>
                                <div class="grid-4 grid-mobile-2 no-gutter-mobile">
                                    <button
                                        id="save-qss-responses"
                                        type="button"
                                        data-tag-commander=""
                                        [appTagCommander]="'tagCo.qss.save.button'"
                                        class="button button--download button--noBackground button-noBg button--primary button--save centered ng-binding ng-isolate-scope"
                                        [ngClass]="{
                                            'icon--loading': saveLoading
                                        }"
                                        (click)="saveQss()"
                                    >
                                        {{ 'qss.button.save' | i18n }}
                                    </button>
                                </div>
                                <div class="grid-4 grid-mobile-2 no-gutter-mobile">
                                    <button
                                        id="qss-validate"
                                        type="submit"
                                        class="button button--primary button--next float-right"
                                        [ngClass]="{
                                            'icon--loading': submitLoading
                                        }"
                                        data-api-call-button=""
                                        data-tag-commander=""
                                        [appTagCommander]="'tagCo.qss.validate.button'"
                                    >
                                        {{ 'qss.button.next' | i18n }}
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</section>

<app-validation-modal-component
    [modalTitle]="'qs.save.title'"
    [content]="'qs.save.message'"
    [buttonLeft]="'qs.save.back'"
    [buttonRight]="'qs.save.resume'"
    [visibility]="showSuccesModal"
    (crossClick)="showSuccesModal = false"
    (leftClick)="navigateToEspaceClient()"
    (rightClick)="showSuccesModal = false"
></app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'qs.save.back'"
    [content]="'adhesion.backToDashboard.modal.body'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [showInfoIcon]="false"
    [visibility]="goBackToEspaceClientModal"
    (crossClick)="goBackToEspaceClientModal = false"
    (leftClick)="goBackToEspaceClientModal = false"
    (rightClick)="navigateToEspaceClient()"
></app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'adhesion.qss.validation.modal.title'"
    [content]="'adhesion.qss.validation.modal.question'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [showInfoIcon]="false"
    [visibility]="postValidateQssModal"
    (crossClick)="postValidateQssModal = false"
    (leftClick)="postValidateQssModal = false"
    (rightClick)="validateQss(qssForm); postValidateQssModal = false"
></app-validation-modal-component>

<app-simple-message-modal [(visibility)]="noChangesModal" [modalTitle]="'qs.save.title'" [content]="'qs.save.inputAnswers'" [closeButton]="'global.close'"></app-simple-message-modal>

<app-steps-adhesion-modal [currentStepId]="'qs'"> </app-steps-adhesion-modal>
